module.exports = __webpack_public_path__ + "img/what-is-openapihub-thumbnail-tc.8adb52f3.jpg";